module.exports = __webpack_public_path__ + "static/ivan-ed9d7c498a7e04e5b52715e6f7b6bbff.png";